import { useQuery } from '@tanstack/react-query'
import { getAdsRewardUser } from '@tmap-web-lib/remote-api-client/frontman'

import { AdsRewardUserResBody } from "@tmap-web-lib/remote-api-client/src/frontman/apis/common/advertisement/types.ts";
import { KEYS } from "./keys.ts";
import { AxiosError } from "axios";

interface Props {
  enabled: boolean;
}


function useAdsRewardUser(props: Props) {
  const { enabled } = props
  return useQuery<AdsRewardUserResBody, AxiosError>({
    queryKey: KEYS.ADS_REWARD_USER(),
    queryFn: async () => (await getAdsRewardUser()).data,
    enabled
  })
}

export { useAdsRewardUser }
